import { WorkshopEstimateRespondApi } from './workshopEstimateRespondApi';

// Formatadores
function formatEstimateDetails(data) {
  const estimate = data.estimativa || data;
  const cliente = data.cliente || {};
  
  return {
    estimativa: {
      id: estimate.id,
      status: estimate.status,
      endereco: estimate.endereco,
      itens: Array.isArray(estimate.itens) ? estimate.itens : JSON.parse(estimate.itens || '[]'),
      texto_resposta: estimate.texto_resposta,
      valor_resposta: estimate.valor_resposta,
      motivo_recusa: estimate.motivo_recusa,
      company_id: estimate.company_id,
      created_at: estimate.created_at
    },
    cliente: {
      id: cliente.id,
      empresa: cliente.nome,
      nome: cliente.contato_nome,
      telefone: cliente.telefone,
      cnpj: cliente.cnpj,
      email: cliente.email,
      dt_criacao: cliente.created_at
    }
  };
}

function formatServicesCatalog(data) {
  if (data.servicos) {
    return data.servicos.map(servico => ({
      id: servico.id,
      nome: servico.descricao || servico.nome,
      tipo: servico.tipo || 'servico',
      valor: servico.valor_unitario || servico.valor,
      valor_2: servico.valor_2 || servico.valor_unitario,
      descricao: servico.descricao,
      codigo: servico.codigo,
      unidade: servico.unidade
    }));
  }
  return Array.isArray(data) ? data : [];
}

function formatarData(dataString) {
  if (!dataString) return '-';
  try {
    return new Date(dataString).toLocaleDateString('pt-BR');
  } catch {
    return '-';
  }
}

function formatarMoeda(valor) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor || 0);
}

// Serviços principais
function getEstimateDetails(estimateId) {
  return WorkshopEstimateRespondApi.getEstimateDetails(estimateId)
    .then(response => formatEstimateDetails(response.data))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao carregar estimativa");
    });
}

function getClientDetails(companyId) {
  return WorkshopEstimateRespondApi.getClientDetails(companyId)
    .then(response => response.data)
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao carregar dados do cliente");
    });
}

function getServicesCatalog() {
  return WorkshopEstimateRespondApi.getServicesCatalog()
    .then(response => formatServicesCatalog(response.data))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao carregar catálogo de serviços");
    });
}

function submitEstimateResponse(estimateId, responseData) {
  return WorkshopEstimateRespondApi.submitEstimateResponse(estimateId, responseData)
    .then(response => ({
      success: true,
      data: response.data,
      message: response.data.message || "Resposta enviada com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao enviar resposta");
    });
}

function createBudget(budgetData) {
  return WorkshopEstimateRespondApi.createBudget(budgetData)
    .then(response => ({
      success: true,
      data: response.data,
      message: response.data.message || "Orçamento criado com sucesso"
    }))
    .catch(error => {
      throw new Error(error.response?.data?.error || "Erro ao criar orçamento");
    });
}

export const WorkshopEstimateRespondService = {
  getEstimateDetails,
  getClientDetails,
  getServicesCatalog,
  submitEstimateResponse,
  createBudget,
  formatarData,
  formatarMoeda
};